import { render, staticRenderFns } from "./CompensatoryLeavesListDeclined.vue?vue&type=template&id=47e905bb&scoped=true"
import script from "./CompensatoryLeavesListDeclined.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesListDeclined.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryLeavesListDeclined.vue?vue&type=style&index=0&id=47e905bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e905bb",
  null
  
)

export default component.exports